var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// /root/anvel/~/isarray/index.js
// module id = ../../../../isarray/index.js
// module chunks = 4